import { render, staticRenderFns } from "./TemplateReportIktForm.vue?vue&type=template&id=7b4505b7&"
import script from "./TemplateReportIktForm.vue?vue&type=script&lang=js&"
export * from "./TemplateReportIktForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports